import { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { RootState } from '../store'

interface RoleProtectedRouteProps {
  children: ReactNode
  allowedRoles: string[]
  fallbackPath?: string
}

const RoleProtectedRoute: FC<RoleProtectedRouteProps> = ({ 
  children, 
  allowedRoles, 
  fallbackPath = '/dashboard' 
}) => {
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth)

  // If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }

  // If user role is not in allowed roles, redirect to fallback
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={fallbackPath} replace />
  }

  return <>{children}</>
}

export default RoleProtectedRoute
